import { render, staticRenderFns } from "./ChangeBtn.vue?vue&type=template&id=d4881344&scoped=true"
import script from "./ChangeBtn.vue?vue&type=script&lang=js"
export * from "./ChangeBtn.vue?vue&type=script&lang=js"
import style0 from "./ChangeBtn.vue?vue&type=style&index=0&id=d4881344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4881344",
  null
  
)

export default component.exports